"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGridList = void 0;
const React = __importStar(require("react"));
const kendo_data_query_1 = require("@progress/kendo-data-query");
const ZGrid_1 = __importDefault(require("../ZGrid/ZGrid"));
const styled_components_1 = __importDefault(require("styled-components"));
class ZGridListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.boundDataStateChangeHandler = this.handleDataStateChange.bind(this);
        this.GridList = (props) => {
            const height = this.props.height, width = this.props.width;
            const styleMemo = React.useMemo(() => ({
                height,
                width
            }), [height, width]);
            return (React.createElement(ZGrid_1.default, Object.assign({ filterable: this.props.filterable, sortable: this.props.sortable, pageable: this.props.pageable || false, filter: this.state.filter, sort: this.state.sort, rowHeight: this.props.height && this.state.take
                    ? (this.props.height - 57) / this.state.take
                    : 50 }, this.props, this.state, { data: this.props.data && kendo_data_query_1.process(this.props.data, this.state), columns: [
                    {
                        cell: this.props.cell
                    }
                ], onDataStateChange: this.boundDataStateChangeHandler, style: styleMemo, resizable: this.props.resizable || true, reorderable: this.props.reorderable || true, scrollable: "scrollable", headerCellRender: () => null })));
        };
        this.state = {
            skip: props.skip || 0,
            take: props.take || 10
        };
    }
    render() {
        const { GridList } = this;
        return React.createElement(GridList, Object.assign({}, this.props));
    }
    handleDataStateChange(e) {
        this.setState(e.dataState);
    }
}
exports.ZGridList = styled_components_1.default(ZGridListComponent) `
   overflow: hidden;
   & .k-grid-norecords {
      display: ${props => (props.pending ? "none" : "table-row")};
   }
   & tbody {
      line-height: 0.5;
   }
   & .k-filter-row,
   .k-grid-header {
      display: none;
   }
   & .k-master-row {
      &:hover {
         background: unset;
      }
   }
   & .z-grid-title {
      font-weight: bold;
      margin: 5px 5px 5px 5px;
   }
   & .k-icon {
      color: ${p => p.theme["app-link-color"]};
      &:hover,
      &:hover::before {
         color: ${p => p.theme["hover-color"]};
      }
      &:active,
      &:active::before {
         color: ${p => p.theme["active-color"]};
      }
   }
`;
exports.default = exports.ZGridList;
//# sourceMappingURL=ZGridList.js.map